import React from "react";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./ButtonBar.module.scss";

interface Props {
  nextButtonConfirmationMessage?: string;
  nextLoading?: boolean;
  onCancelClick: () => void;
  onNextClick: () => void;
}

const ButtonBar: React.FC<Props> = ({
  nextButtonConfirmationMessage,
  nextLoading,
  onCancelClick,
  onNextClick,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <Button onClick={onCancelClick} type="default">
        {intl.formatMessage({
          id: "reports.weeklyReportCard.buttonBar.cancel",
          defaultMessage: "Revert changes",
          description: "Text of Revert changes button",
        })}
      </Button>
      <Button
        className={styles.nextButton}
        disabled={nextLoading}
        loading={nextLoading}
        onClick={nextButtonConfirmationMessage ? undefined : onNextClick}
        type="primary"
      >
        {intl.formatMessage({
          id: "reports.weeklyReportCard.buttonBar.nextButtonTitle",
          defaultMessage: "Save report preferences",
          description: "Text of save preferences button",
        })}
      </Button>
    </div>
  );
};

export default ButtonBar;
